import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import Splide from '@splidejs/splide';

const Sliders = () => {
	// Inicjalizacja Swipera dla ".for-who-slider"
	const forWhoSlider = new Swiper(".for-who-slider", {
        modules: [ Navigation, Pagination, Autoplay ],
		slidesPerView: 'auto',
        spaceBetween: 20,
		pagination: {
			el: ".for-who__wrapper-items-pagination",
			type: "bullets",
		},
		loop: true,
		autoplay: {
			delay: 5000,
		},
	});

    const twoColumnsSlider = document.querySelectorAll('.opinions__wrapper-left-top-slider');

    twoColumnsSlider.forEach(slider => {
        const twoColumnsNext = slider.closest('.opinions__wrapper').querySelector('.opinions__wrapper-navigation-next');
        const twoColumnsPrev = slider.closest('.opinions__wrapper').querySelector('.opinions__wrapper-navigation-prev');
    
        const twoColumns = new Splide(slider, {
            type: 'loop',
            perPage: 1,
            pagination: false,
            arrows: false,
            reducedMotion: {
                interval: 4000,
                speed: 800,
                autoplay: 'play'
            }
        }).mount();
    
        if (twoColumnsNext) {
            twoColumnsNext.addEventListener('click', () => {
                twoColumns.go('+1');
            });
        }
    
        if (twoColumnsPrev) {
            twoColumnsPrev.addEventListener('click', () => {
                twoColumns.go('-1');
            });
        }
    });

    const simpleOpinionsSlider = document.querySelector('.simple-opinions__wrapper-slider');

    if(simpleOpinionsSlider) {
        const simpleOpinionsNext = simpleOpinionsSlider.querySelector('.simple-opinions__wrapper-slider-navigation-next');
        const simpleOpinionsPrev = simpleOpinionsSlider.querySelector('.simple-opinions__wrapper-slider-navigation-prev');
    
        const simpleOpinions = new Splide('.simple-opinions__wrapper-slider', {
            type: 'loop',
            perPage: 3,
            pagination: false,
            arrows: false,
            gap: 68,
            reducedMotion: {
                interval: 4000,
                speed: 800,
                autoplay: 'play'
            },
            breakpoints: {
                1300: {
                    gap: 20,
                },
                1200: {
                    perPage: 2,
                },
                1024: {
                    perPage: 1,
                }
              }
        }).mount();
    
        if (simpleOpinionsNext) {
            simpleOpinionsNext.addEventListener('click', () => {
                simpleOpinions.go('+1');
            });
        }
    
        if (simpleOpinionsPrev) {
            simpleOpinionsPrev.addEventListener('click', () => {
                simpleOpinions.go('-1');
            });
        }
    }


};

export default Sliders;